'use client';

import clsx from 'clsx';

import { breakpoints } from '@/app.config';

import { CardImage } from '@/components/Card';
import { useCardHover } from '@/components/Card';
import styles from '@/components/CollectionCard/CollectionCard.module.scss';

// =================================================================

const CARD_ASPECT_RATIO = 500 / 300;

// =================================================================

interface CollectionCardImageProps {
  poster: string;
  title: string;
}

// =================================================================

export const CollectionCardImage = (props: CollectionCardImageProps) => {
  const { poster, title } = props;

  const { ref, isHovered } = useCardHover<HTMLDivElement>();

  return (
    <div ref={ref} className={styles.imageContainer}>
      <span
        style={{ backgroundImage: `url(${poster})` }}
        className={clsx(styles.stackImage, styles.stackImageRear)}
      />
      <span
        style={{ backgroundImage: `url(${poster})` }}
        className={clsx(styles.stackImage, styles.stackImageMiddle)}
      />
      <CardImage
        as="div"
        src={poster}
        alt={title}
        aspectRatio={CARD_ASPECT_RATIO}
        className={clsx({ [styles.cardImageHover]: isHovered })}
        sizes={`100vw, ${breakpoints.small} 50vw, ${breakpoints.large} 33vw`}
      />
    </div>
  );
};
